var _effectorFileName = "/builds/gmini/front-common/src/Explorer/ctx/icons.tsx";
import { CreateNewFolder, DeleteForever, Edit, FileCopy, FolderShared, Storage } from '@mui/icons-material';
import { IconWrap } from "./icons.styled";
import { jsx as _jsx } from "react/jsx-runtime";
export var CreateFolderIcon = /*#__PURE__*/_jsx(IconWrap, {
  children: /*#__PURE__*/_jsx(CreateNewFolder, {})
});
export var RenameIcon = /*#__PURE__*/_jsx(IconWrap, {
  children: /*#__PURE__*/_jsx(Edit, {})
});
export var DeleteIcon = /*#__PURE__*/_jsx(IconWrap, {
  children: /*#__PURE__*/_jsx(DeleteForever, {})
});
export var CreateCopyIcon = /*#__PURE__*/_jsx(IconWrap, {
  children: /*#__PURE__*/_jsx(FileCopy, {})
});
export var CreateEntityIcon = /*#__PURE__*/_jsx(IconWrap, {
  children: /*#__PURE__*/_jsx(FolderShared, {})
});
export var AssemblyCtxIcon = /*#__PURE__*/_jsx(IconWrap, {
  children: /*#__PURE__*/_jsx(Storage, {})
});